const DATA = [
    {
        id : 0,
        title : "BYREDO - MUMBAI NOISE",
        price : 125,
        desc : "Mumbai Noise – a tribute to the sensorial multitudes and multifaceted modernity of Mumbai, anchored in Ben Gorham’s memories of its past. A scent crowded with contrasts: of rich, warm woods and amber blended with brightness; of plummy Davana positioned alongside leather; bitter coffee stirred with sweet tonka beans. The mesmerising abundance of Chembur’s streets – the smoky haze of incense interspersed with streetside coffee carts and cacophonous soundscapes – is explored through a contemporary lens.",
        img : "/assets/images/products/byredo.png"
    },
    {
        id : 1,
        title : "LOUIS VUITTON - DANCING BLOSSOM",
        price : 112,
        desc : "Let yourself be swept away, far away, to explore the constantly changing kingdom of the seasons. To contemplate the extraordinary lushness of nature, Jacques Cavallier Belletrud has chosen to interpret an intensely floral expression, both delicate and powerful. The exquisitely precious Grasse rose unfurls its majestic splendour, while Sambac jasmine and Indian tuberose embellish the composition with their fleshy beauty. Chinese osmanthus complements the bouquet with its fruity apricot inflection. An extraordinarily prolific swirl of petals, a colourful yet subtle bouquet of sweeping emotions.",
        img : "/assets/images/products/louis.png"
    },
    {
        id : 2,
        title : "DIOR - J'ADORE",
        price : 195,
        desc : "An iconic fragrance, J’adore Eau de Parfum is the grand feminine floral by the House of Dior.Finely crafted down to the last detail, like a custom-made flower, J'adore is a bouquet of the most beautiful flowers from around the world. Essence of Ylang-Ylang with its floral and fruity notes and essence of Damascus Rose from Turkey blend with a rare duo of Jasmine Grandiflorum from Grasse and Indian Jasmine Sambac, with fruity and voluptuous sensuality.",
        img : "/assets/images/products/dior.png"
    },
    {
        id : 3,
        title : "MAISON FRANCIS KURKDJIAN - BACCARAT ROUGE 540",
        price : 350,
        desc : "Baccarat Rouge 540 eau de parfum is born from the encounter between Maison Francis Kurkdjian and Baccarat to celebrate the crystal manufacturer’s 250th birthday. The woody scent releases a poetic alchemy, a highly condensed and graphic olfactory signature. Breezy jasmine facets, radiant saffron boost the ambergris mineral notes and the woody tones of freshly-cut cedar. Bright and sleek, Baccarat Rouge 540 eau de parfum caresses the skin like an amber and woody floral whisper.",
        img : "/assets/images/products/maison.png"
    },
    {
        id : 4,
        title : "TOM FORD - BLACK ORCHID",
        price : 220,
        desc : "BORN OF TOM FORD’S QUEST FOR THE PERFECT FLOWER, THE ICONIC BLACK ORCHID FRAGRANCE IS A DEEPLY SEDUCTIVE POTION OF BLACK ORCHIDS, SPICE AND DARK ACCORDS. ABOUT THE FRAGRANCE: A LUXE AND EXTRAORDINARY FRAGRANCE OF RICH, DARK ACCORDS MERGED WITH A SENSUAL COMPOSITION OF BLACK ORCHIDS AND SPICE, BLACK ORCHID IS BOTH MODERN AND TIMELESS – AN HOMAGE TO WORLDLY GLAMOUR AND ICONIC STYLE.",
        img : "/assets/images/products/tom.png"
    },
    {
        id : 5,
        title : "JO MALONE LONDON - RED ROSES COLOGNE",
        price : 95,
        desc : "The essence of modern romance, inspired by a voluptuous blend of seven of the world's most exquisite roses. With crushed violet leaves and a hint of lemon, it unfolds like a bouquet of freshly cut flowers.",
        img : "/assets/images/products/jo.png"
    }
]

export default DATA;